import React from "react";
const Extras = () => {
  return (
    <>
      <section className="extras">
        <div className="extras-grid">
          <div className="extras-element">
            <img
              className="extras-icon"
              src="https://static1.hkrtcdn.com/hknext/static/media/common/misc/hk-cash-icon.svg"
              alt="Hk cash"
            />
            <span className="extras-heading"> Earn HK Cash </span>
            <span className="extras-text">
              Shop with us and get HK Cash to redeem on your next purchase
            </span>
          </div>
          <div className="extras-element">
            <img
              className="extras-icon"
              src="	https://static1.hkrtcdn.com/hknext/static/media/common/misc/safe-payment-icon.svg
          "
              alt="Safe Payment"
            />
            <span className="extras-heading"> Safe Payment </span>
            <span className="extras-text">
              Pay with the world’s most popular and secure payment methods.
            </span>
          </div>
          <div className="extras-element">
            <img
              className="extras-icon"
              src="https://static1.hkrtcdn.com/hknext/static/media/common/misc/authenticity-icon.svg"
              alt="Authenticity Guaranteed"
            />
            <span className="extras-heading"> Earn HK Cash </span>
            <span className="extras-text">
              100% authentic products for our customers
            </span>
          </div>
          <div className="extras-element">
            <div>
              <img
                className="extras-icon android-icon"
                src="	https://static1.hkrtcdn.com/hknext/static/media/common/misc/andriod-icon.svg"
                alt="Android"
              />
              <img
                className="extras-icon apple-icon"
                src="		https://static1.hkrtcdn.com/hknext/static/media/common/misc/apple-icon.svg"
                alt="Apple"
              />
            </div>
            <span className="extras-heading"> Download Healthkart App </span>
            <span className="extras-text">
              Get the best experience of Healthkart at your fingertips.
            </span>
          </div>
        </div>
      </section>
    </>
  );
};

export default Extras;
